import React, { useEffect } from 'react';
import { View, ScrollView } from 'react-native';
import { useSelector } from 'react-redux';
import Typography from '../../../../components/Text/Text';
import Checkbox from '../../../../components/Checkbox/Checkbox';
import NavigationButtons from '../../components/NavigationButtons';
import { styles } from './ConfirmationScreen.styles';
import { useConfirmation } from './useConfirmation';
import { CONFIRMATION_TEXT } from './ConfirmationText';
import { trackGTMEvent } from 'src/helpers/gtm/gtmEvents';
import Loader from 'src/components/loadingTruck/loadingTruck';
import { RootState } from 'src/store/store';

const ConfirmationScreen: React.FC = () => {
  const accountType = useSelector((state: RootState) => state.UI.accountType);
  // const showGlobalLoader = useSelector((state: RootState) => state.UI.showGlobalLoader);

  const { isChecked, handleCheckboxChange, navigateToPolicy, navigateToQuote, isLoading } =
    useConfirmation();

  useEffect(() => {
    // Track page landing event
    trackGTMEvent(
      'acknowledgement-screen-landed',
      {
        userEvent: 'User landed on the Acknowledgement screen',
      },
      accountType,
    );
  }, []);

  if (isLoading) {
    return <Loader text="Loading..." />;
  }

  return (
    <View style={styles.container}>
      {/* Scrollable Text */}
      <ScrollView style={styles.scrollableTextContainer} showsVerticalScrollIndicator={true}>
        <Typography variant="body2">{CONFIRMATION_TEXT}</Typography>
      </ScrollView>

      {/* Confirmation Checkbox */}
      <View style={styles.checkboxContainer}>
        <Checkbox active={isChecked} onChange={handleCheckboxChange} testID={'agreement-check'} />
        <Typography variant="body1">
          I agree to the above statements and that everything I’ve listed in this application is
          true and accurate
        </Typography>
      </View>

      {/* Navigation Buttons */}
      <NavigationButtons
        testID={'confirmation-final-page-btn'}
        isNextDisabled={!isChecked}
        onBack={navigateToPolicy}
        onNext={navigateToQuote}
      />
    </View>
  );
};

export default ConfirmationScreen;
